import { Component, Input, OnInit } from '@angular/core';
import { getPrettyPropertyRecordCalculationStatus } from 'src/app/shared';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';

@Component({
    standalone: false,
    selector: 'app-process-statistic-selection-calc-pr-multi-thread',
    templateUrl: './process-statistic-selection-calc-pr-multi-thread.component.html',
    styleUrls: ['./process-statistic-selection-calc-pr-multi-thread.component.scss']
})
export class ProcessStatisticSelectionCalcPrMultiThreadComponent implements OnInit {
    @Input()
    process: ITaskModel;

    constructor() { }

    ngOnInit(): void { }

    statusFormatter(calculationStatusCode: number): string {
        return getPrettyPropertyRecordCalculationStatus(calculationStatusCode);
    }
}
